
import { Component,ViewEncapsulation, OnInit, Renderer2, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { loadModules } from 'esri-loader';
import { environment } from '../../environments/environment'
import { ApiService } from '../services/api.service';
import esri = __esri;


@Component({
  selector: 'esri-map',
  template: ``,
  encapsulation: ViewEncapsulation.None,
})
export class EsriMapComponent implements OnInit {

  @Output() mapLoaded = new EventEmitter<boolean>();

  @Input() zoom: number;
  @Input() webmapId: string;
  @Input() basemap:string;
  @Input() ground:string;

  constructor(private el: ElementRef, private renderer: Renderer2,private apiService: ApiService)  { }

  async initializeMap() {
    
    try {
      const [EsriMap,WebMap, EsriMapView,EsriServerInfo,EsriCredential,IMB,Legend] = await loadModules([
        'esri/Map',
        'esri/WebMap',
        'esri/views/MapView',
        'esri/identity/ServerInfo',
        'esri/identity/Credential',
        'esri/identity/IdentityManagerBase', 
        "esri/widgets/Legend",
        'dojo/domReady!'
      ]);

      const nativeElement: HTMLElement = this.el.nativeElement;
      const mapDiv = this.renderer.createElement('div');


      mapDiv.style.width = '100%';
      mapDiv.style.height = '100%';

      this.renderer.appendChild(nativeElement, mapDiv)

      const mapProperties: esri.MapProperties = {
        basemap: "hybrid",
        ground: "world-elevation"
      };

     
      // let body = JSON.parse('{"esriUrl": "'+environment.esriTokenUrl+
      //                     '","esriUser":"'+environment.esriUser+
      //                     '","esriPassword":"'+environment.esriPassword+
      //                     '","referer":"'+environment.esriClient+
      //                     '"}');

      // this.apiService.postAs<any>('ClientCustom/GenerateEsriToken',body).then(response => {
     
      //   console.log(response)

      //  let tokenObject = JSON.parse(response);
          
      //   var serverinfos : esri.ServerInfo[] = [];
      //   var serverinfo : esri.ServerInfo = new EsriServerInfo();
      //   serverinfo.server = "https://vitmap.scheidvineyards.com:6443";
      //   serverinfo.tokenServiceUrl= "https://vitmap.scheidvineyards.com:6443/arcgis/tokens/"; 
      //   serverinfo.adminTokenServiceUrl="https://vitmap.scheidvineyards.com:6443/arcgis/admin/generateToken";  
      //   serverinfo.shortLivedTokenValidity = 60;
      //   serverinfos.push(serverinfo);

      //   var credentials: esri.Credential[] = [];
      //   var credential : esri.Credential = new EsriCredential();
      //   credential.userId = environment.esriUser; 
      //   credential.server =  "https://vitmap.scheidvineyards.com:6443";  
      //   credential.token =  tokenObject.token;
      //   credential.expires = tokenObject.expires;
      //   credentials.push(credential);

      //   var identity: esri.IdentityManagerBase = new IMB();
      //   identity.useSignInPage = false;

      //   var credentialsJSON : any = {serverinfos,credentials};

      //   let tokenProperties : any = {
      //     expires: tokenObject.expires,
      //     server: "https://vitmap.scheidvineyards.com:6443/arcgis/rest/services",
      //     ssl: false,
      //     token:  tokenObject.token,
      //     userId: environment.esriUser
      //   };

      //   identity.toJSON();
      //   identity.initialize(credentialsJSON);
      //   identity.registerToken(tokenProperties);
        

        var webmap = new WebMap({
          portalItem: { 
            id: this.webmapId
          }
        });
  
       const mapViewProperties: esri.MapViewProperties = {
          container: mapDiv,
          map: webmap,
          
        };

        const mapView: esri.MapView = new EsriMapView(mapViewProperties);
    
        mapView.when(() => {

            // when the resources in the MapView have loaded.
            var featureLayer = webmap.layers.getItemAt(0);

              var legend = new Legend({
                view: mapView,
                layerInfos: [{
                  layer: featureLayer
                }]
              });

            mapView.ui.add(legend, "bottom-right");
            this.mapLoaded.emit(true);                
        });

    //  });

    } catch (error) {
      console.log('We have an error: ' + error);
    }

  }

  ngOnInit() {
    this.initializeMap();
  }

}



// WEBPACK FOOTER //
// ./src/app/helpers/esri-map.component.ts